import React, { Fragment, useState } from "react"
import { Col, Row, ModalBody, ModalFooter } from "reactstrap"
import { withTranslation } from "react-i18next"
import { CustomModal, CustomButton, CustomSelect } from "components/Common"
import { AvForm } from "availity-reactstrap-validation"
import { parameterCode } from "constant"

const FilterHeader = ({ t, onFilterChange, currentFilters = {}, loading }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [filterModel, setFilterModel] = useState({
        periodOption: currentFilters.periodOption || "1",
        category: currentFilters.category || "",
    })

    const periodOptions = [
        { value: "1", label: t("Day") },
        { value: "2", label: t("Week") },
        { value: "3", label: t("Month") },
        { value: "4", label: t("Quarter") },
    ]

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
        if (!isModalOpen) {
            setFilterModel({
                periodOption: currentFilters.periodOption || "1",
                category: currentFilters.category || "",
            })
        }
    }

    const applyFilters = () => {
        onFilterChange(filterModel)
        setIsModalOpen(false)
    }

    const resetFilters = () => {
        const defaultFilters = {
            periodOption: "1",
        }
        setFilterModel(defaultFilters)
        onFilterChange(defaultFilters)
        setIsModalOpen(false)
    }

    const getCurrentFilterLabel = () => {
        const option = periodOptions.find(opt => opt.value === currentFilters.periodOption)
        return option?.label || t("Day")
    }

    return (
        <Fragment>
            {/* Filter Row */}
            <Row className="align-items-center">
                <Col lg="9" md="8" sm="6">
                    <div className="d-flex align-items-center">
                        <span className="me-3 mb-0 fw-medium" style={{
                            fontSize: "14px",
                            color: '#495057'
                        }}>
                            {t("Current Filter") || "Current Filter"}:
                        </span>
                        <span className="badge bg-primary fs-6 py-2 px-3">
                            {getCurrentFilterLabel()}
                        </span>

                        <span className="ms-3 badge bg-primary fs-6 py-2 px-3">
                            {filterModel.category}
                        </span>
                    </div>
                </Col>
                <Col lg="3" md="4" sm="6" className="text-end">
                    <div className="d-flex justify-content-end align-items-center gap-3">
                        <span className="text-muted small">
                            {t("common:Updated Date")}: {new Date().toLocaleString()}
                        </span>
                        <CustomButton
                            disabled={loading}
                            color="outline-primary"
                            onClick={toggleModal}
                            style={{
                                borderRadius: '6px',
                                padding: '8px 12px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px'
                            }}
                        >
                            <i className="mdi mdi-filter-variant"></i>
                            {t("Filter") || "Filter"}
                        </CustomButton>
                    </div>
                </Col>
            </Row>

            {/* Filter Modal using CustomModal */}
            <CustomModal
                modal={isModalOpen}
                title={t("Dashboard Filters") || "Dashboard Filters"}
                onToggle={toggleModal}
                size="md"
            >
                <ModalBody style={{ minHeight: '300px', paddingTop: '20px', paddingBottom: '20px' }}>
                    <AvForm>
                        <Row>
                            <div className="mb-3">
                                <CustomSelect
                                    name="periodOption"
                                    portal
                                    value={filterModel.periodOption || ""}
                                    options={periodOptions}
                                    label={t("Time Period") || "Time Period"}
                                    onChange={(name, value, label, item) => {
                                        setFilterModel(prev => ({
                                            ...prev,
                                            periodOption: value[0]
                                        }))
                                    }}
                                />
                            </div>
                        </Row>
                        <Row>
                            <CustomSelect
                                label={t("common:Category")}
                                name="category"
                                value={filterModel.category}
                                code={parameterCode.TEST_CATEGORIES}
                                onChange={(e, values) => {
                                    setFilterModel({ ...filterModel, category: values[0] ? values[0] : '' });
                                }}
                            />
                        </Row>
                    </AvForm>
                </ModalBody>
                <ModalFooter>
                    <CustomButton
                        color="outline-secondary"
                        onClick={resetFilters}
                    >
                        <i className="mdi mdi-refresh me-1"></i>
                        {t("Reset") || "Reset"}
                    </CustomButton>
                    <CustomButton
                        color="primary"
                        onClick={applyFilters}
                    >
                        <i className="mdi mdi-check me-1"></i>
                        {t("Apply Filters") || "Apply Filters"}
                    </CustomButton>
                </ModalFooter>
            </CustomModal>
        </Fragment>
    )
}

export default withTranslation(["generalDashboard", "common"])(FilterHeader) 